/*
 * Wythout — mobile sticky Add-to-Cart.
 *
 * Reveals a fixed bottom bar (≤1024px — the mobile-layout range) once the real product buy button
 * has been seen once and then scrolls out of view — first paint stays clean until the shopper
 * has reached the natural button. Submits the REAL product form on tap so the custom
 * subscription selector's variant id + selling_plan are preserved. The price
 * mirrors the selector's active price. No dependency on the theme's native
 * sticky-add-to-cart snippet (which posts a separate form without selling_plan).
 */
(function () {
  var mobileMql = window.matchMedia('(max-width: 1024px)');

  document.querySelectorAll('.wythout-sticky-atc').forEach(function (bar) {
    var form = document.getElementById(bar.getAttribute('data-form'));
    if (!form) return;

    var realBtn = form.querySelector('[name="add"], .product-form__submit');
    var anchor = realBtn || form;
    var btn = bar.querySelector('.wythout-sticky-atc__btn');
    var priceEl = bar.querySelector('[data-role="sticky-price"]');
    var selector = document.querySelector('.subscription-selector');
    var visible = false;

    function mirrorPrice() {
      if (!priceEl) return;
      var active = selector && selector.querySelector(
        '.sub-purchase.is-active [data-role="price-subscribe"], .sub-purchase.is-active [data-role="price-onetime"]'
      );
      // Trial selector: no purchase-type rows — mirror its single price line
      // ("Free trial pack — $0 today").
      if (!active && selector) active = selector.querySelector('.trial-selector__price');
      // Fallback: Minion's selling-price node. (.price__regular here is the
      // strikethrough compare-at, NOT the selling price — never mirror it.)
      if (!active) active = document.querySelector('.product__price .price__main__value');
      priceEl.textContent = active ? active.textContent.trim() : '';
    }

    function submit() {
      if (realBtn) realBtn.click();
      else if (form.requestSubmit) form.requestSubmit();
    }

    function setShown(show) {
      if (show === visible) return;
      visible = show;
      if (show) {
        bar.hidden = false;
        bar.setAttribute('aria-hidden', 'false');
        mirrorPrice();
        requestAnimationFrame(function () { bar.classList.add('is-visible'); });
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    btn.addEventListener('click', submit);

    // Reveal when the real button leaves the viewport — mobile only, and only
    // after it has been in view at least once. On load the buy area sits below
    // the full-bleed hero, so without the gate the bar would cover the page
    // before the shopper ever reached the real button.
    var seenOnce = false;
    var io = new IntersectionObserver(function (entries) {
      if (!mobileMql.matches) { setShown(false); return; }
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          seenOnce = true;
          setShown(false);
        } else if (seenOnce) {
          setShown(true);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(anchor);

    // Keep the mirrored price fresh as the user changes roll count / plan / type.
    if (selector) {
      selector.addEventListener('click', function () { setTimeout(mirrorPrice, 0); });
    }

    // Collapse if the viewport grows past mobile.
    mobileMql.addEventListener('change', function () { if (!mobileMql.matches) setShown(false); });

    // Drop out of the a11y tree + layout once the hide transition finishes.
    bar.addEventListener('transitionend', function () { if (!visible) bar.hidden = true; });
  });
})();
